// Types
import { BreakpointSize } from '../types/global';

export const BREAKPOINTS: BreakpointSize = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
} as const;
